import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import { disableBackButton } from '../../ConstantComponents/Constants'
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import { Avatar, Card, CardContent, CardHeader, Chip, Divider, Grid, MenuItem, Modal, TextField, Tooltip, Backdrop } from '@mui/material';

import config from '../../../config.json'
import axios from 'axios';
import '../../../customcss/loadernew.css'

import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';
import moment from 'moment';
import CountUp from 'react-countup';
import TimeSeriesChartComponent from './TimeSeriesChartComponent';

const BASE_URL = config.SERVER_URL

export default function MarketPage() {

    disableBackButton()

    const drawerWidth = 300;

    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };


    /////////////////////////////// variables ///////////////////////////
    const [backdropopen, setbackdropopen] = useState(true)
    const [timeseries, settimeseries] = useState([])
    const [state, setstate] = useState(0)
    const [statemaster, setstatemaster] = useState([])

    const [markettotal, setmarkettotal] = useState(0)
    const [marketenteric, setmarketenteric] = useState(0)

    const [marketcooked, setmarketcooked] = useState([])
    const [marketuncooked, setmarketuncooked] = useState([])

    const [statewisestrain, setstatewisestrain] = useState([])

    const [minLabel, setminLabel] = useState(98)

    const [states, setstates] = useState([])



    const inputlabelprops = {
        style: { color: '#45a2fa', fontSize: '17px' }
    }


    function getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    function handleResize() {
        const newWidth = getScreenWidth();


        if (newWidth <= 1920 && newWidth > 1600) {
            setminLabel(99)
        } else if (newWidth <= 1600 && newWidth > 1200) {
            setminLabel(79)
        } else if (newWidth <= 1200 && newWidth > 1000) {
            setminLabel(59)
        } else if (newWidth <= 1000 && newWidth > 800) {
            setminLabel(39)
        } else if (newWidth <= 800 && newWidth > 600) {
            setminLabel(10)
        } else if (newWidth <= 600 && newWidth > 500) {
            setminLabel(19)
        } else if (newWidth <= 500 && newWidth > 400) {
            setminLabel(2)
        }

        // Your other actions on resize, e.g., update layout
    }

    window.addEventListener('resize', handleResize);

    // Call the function initially to get the initial screen width
    const initialWidth = getScreenWidth();

    useEffect(() => {
        if (initialWidth <= 1920 && initialWidth > 1600) {
            setminLabel(99)
        } else if (initialWidth <= 1600 && initialWidth > 1200) {
            setminLabel(79)
        } else if (initialWidth <= 1200 && initialWidth > 1000) {
            setminLabel(59)
        } else if (initialWidth <= 1000 && initialWidth > 800) {
            setminLabel(39)
        } else if (initialWidth <= 800 && initialWidth > 600) {
            setminLabel(10)
        } else if (initialWidth <= 600 && initialWidth > 500) {
            setminLabel(19)
        } else if (initialWidth <= 500 && initialWidth > 400) {
            setminLabel(2)
        }
    }, [])





    // jwt working//


    const navigate = useNavigate()
    const t1 = sessionStorage.getItem("sessionid")

    //////console.log("token from redux at enter strain page", t1)

    var decodet1 = ""

    try {
        decodet1 = jwtDecode(t1)
    } catch (error) {

    }

    useEffect(() => {

        const getState = axios.post(BASE_URL + '/master/getStatesnew', {}, { withCredentials: true })
        const getPositivityCount = axios.post(BASE_URL + '/dashboard/getPositivityCard', {}, { withCredentials: true })
        const getSourceWiseCount = axios.post(BASE_URL + '/dashboard/getSourceWiseMarket', {}, { withCredentials: true })
        const getStateWiseCount = axios.post(BASE_URL + '/dashboard/getStateWiseStrainMarket', {}, { withCredentials: true })
        const getStates = axios.post(BASE_URL+"/master/getStates",
            {},
            { withCredentials: true }
        );

        Promise.all([getState, getPositivityCount, getSourceWiseCount, getStateWiseCount,getStates])
            .then(function (responses) {



                setstatemaster(responses[0].data.States)

                setmarkettotal(responses[1].data.TotalMarket)
                setmarketenteric(responses[1].data.EntericMarket)

                setmarketcooked(responses[2].data.Cooked)
                setmarketuncooked(responses[2].data.Uncooked)

                //console.log("resp===:", responses[3].data)
                setstatewisestrain(responses[3].data)

                setstates(responses[4].data.States)



                setbackdropopen(false)


            }).catch(function (errors) {

            });

    }, [])

    useEffect(() => {

        setbackdropopen(true)

        const params = new URLSearchParams();

        params.append("state", state)

        const getPositivityCount = axios.post(BASE_URL + '/dashboard/getTimeSeries', params, { withCredentials: true })

        Promise.all([getPositivityCount])
            .then(function (responses) {

                //console.log("path data----:", responses[0].data)

                settimeseries(responses[0].data)

                setbackdropopen(false)


            }).catch(function (errors) {

            });
    }, [state])



    const cardShadow = 'rgba(3, 102, 214, 0.3) 0px 19px 38px, rgba(3, 102, 214, 0.3) 0px 15px 12px'



    // const dataseries = timeseries.map(item => [moment(item.date).format(),item.count])

    // // const dataseries = timeseries.map(item => ({
    // //     date : item.date,
    // //     count: item.count
    // // }))


    // console.log("data--: ", dataseries)

    //////////////// time series data config /////////////////

    const timedatapath = []

    for (const pathogen in timeseries) {
        timedatapath.push({
            pathname: pathogen,
            series: timeseries[pathogen].map(item => [moment(item.date).format(), item.count])
        })
    }

    timedatapath.sort((a, b) => b.series.length - a.series.length);



    //////////////////////////////// barchart config ////////////////////////////////////



    const dataArray = []

    // const firstPathogenKey = Object.keys(statewisestrain)[0];
    // const stateName = statewisestrain[firstPathogenKey].map(stateInfo => stateInfo.stateName);

    // console.log(stateName);

    // console.log("key===:", firstPathogenKey)

    const stateNames = states.map(item => item.stateName)

    for (const pathogen in statewisestrain) {
        //stateNames.push(statewisestrain[pathogen].map(item => item.stateName))

        //console.log("path:==", statewisestrain[pathogen].map(item => item.stateName))

        const pathogenData = []

        for (const state of statewisestrain[pathogen]) {
            pathogenData.push(state.count)

        }

        dataArray.push({
            name: pathogen,
            type: 'bar',
            data: pathogenData.map((value, i) => ({
                value: value,
                itemStyle: value === 0 ? { opacity: 0 } : {},
            })),

            label: {
                show: true,
                position: 'top',
                fontSize: 12,
                fontWeight: 600,
                color: '#000000'
            },
            emphasis: {
                focus: 'series'
            }

        });

    }


    const baroption2 = {
        title: {
            text: 'Strains by States',
            show: false
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'top',
            feature: {
                dataView: {
                    title: 'Table View',
                    readOnly: false,
                    lang: ['<div style="margin-bottom: 5px"><center>TABLE VIEW</center></div>', 'Close', 'Refresh'],
                    optionToContent: function (opt) {
                        var axisData = opt.xAxis[0].data;
                        var series = opt.series;
                        var table = '<center><table style="width:85%;text-align:center;border: 2px solid #000000; border-radius: 10px"><thead><tr>'
                            + '<th style="background-color: #bbbdbd; padding: 10px; border: 1px solid #000000; ">States</th>'
                            + series.map(function (item) {
                                return '<th style="background-color: #bbbdbd; border: 1px solid #000000;">' + item.name + '</th>';
                            }).join('')
                            + '</tr></thead><tbody>';

                        for (var i = 0, l = axisData.length; i < l; i++) {
                            var rowColor = i % 2 === 0 ? '#ffffff' : '#e8eded';
                            table += '<tr style="background-color: ' + rowColor + '; padding: 20px; border: 1px solid #000000;">'
                                + '<td style=" padding: 5px; border: 1px solid #000000; ">' + axisData[i] + '</td>'
                                + series.map(function (item) {
                                    return '<td style="border: 1px solid #000000;">' + (item.data[i] || '0') + '</td>';
                                }).join('')
                                + '</tr>';
                        }

                        table += '</tbody></table></center>';
                        return table;
                    }
                },
                saveAsImage: {}
            }
        },
        legend: {},
        grid: {
            left: '1%',
            right: '1%',
            bottom: '1%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 15,
                fontWeight: 600,
                color: '#000000'
            }
        },
        xAxis: {
            type: 'category',
            data: stateNames,
            axisTick: {
                alignWithLabel: true
            },
            axisLabel: {
                fontSize: 15,
                fontFamily: 'Rubik, sans-serif',
                fontWeight: 500,
                color: 'black',
                interval: 0,
                formatter: function (value, index) {
                    return dataArray[index] === 0 ? '' : value; // Return empty string for zero values
                }

            },
        },
        series: dataArray,
        height: 280,
        dataZoom: [{
            type: 'slider',
            show: true,
            start: 2,
            end: minLabel,
            handleSize: '550%',
            height: 1,
            backgroundColor: '#0715ad', // Background color of the slider
            dataBackgroundColor: '#0715ad', // Background color of the data area
            fillerColor: '#0715ad', // Color of the selected area (filler)
            handleColor: '#0715ad', // Color of the handles
            borderColor: '#0715ad',
            labelFormatter: () => '',

        }],
    };


    //////////////////////////// pie chart config ///////////////////////////////

    /**
     * uncooked
     */

    const chartdatapie = marketuncooked.map(item => (
        {
            value: item.sum,
            name: item.sampleCategoryName
        }
    ))


    const pieoption1 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal',
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                top: '10%',
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie
            }
        ]
    };

    /**
     * cooked
     */

    const chartdatapie2 = marketcooked.map(item => (
        {
            value: item.sum,
            name: item.sampleCategoryName
        }
    ))


    const pieoption2 = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            left: 'center',
            orient: 'horizontal',
        },
        series: [
            {
                //name: 'Access From',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                top: '10%',
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                padAngle: 2,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: true,
                        fontSize: 20,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: chartdatapie2
            }
        ]
    };






    return (
        <>
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#f3f4f7',
                    scrollbarWidth: 'none', // For Firefox
                    msOverflowStyle: 'none', // For Internet Explorer and Edge
                    '&::WebkitScrollbar': {
                        display: 'none', // For Chrome, Safari, and Edge
                    },
                }}>
                <Sidebar />
                <div style={{ marginTop: '100px', marginLeft: "25px", backgroundColor: '#f3f4f7' }}>

                    <Box component="main" sx={{ p: 1, backgroundColor: '#f3f4f7', height: '100%' }}>

                        <Grid container spacing={4} justifyContent="center" alignItems="center" >

                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} >
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'blue' }}><CountUp end={markettotal} /></h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Samples Tested</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'green' }}><CountUp end={marketenteric} /></h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Enteric Pathogens</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                                <div style={{
                                    backgroundColor: 'white', borderRadius: '5px', padding: '20px', marginLeft: '10px', width: '100%', boxShadow: cardShadow
                                }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'red' }}>{(marketenteric / markettotal * 100).toFixed(2)}%</h3>
                                    <h6 className="rubik-font" style={{ fontWeight: 400, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Positivity</h6>

                                    {/* <ReactECharts option={option3} style={{ height: '100px', width: '100%' }} /> */}

                                </div>
                            </Grid>

                        </Grid>

                        <h3 className="rubik-font" style={{ marginLeft: '15px', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginTop: '100px' }}>Enteric Pathogens by State</h3>

                        <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 1 }} >
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >

                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Identified Strains Accross States</h3>
                                    {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>State Wise Count</h5> */}
                                    <ReactECharts option={baroption2} style={{ height: '400px', width: '100%' }} />

                                </div>
                            </Grid>

                        </Grid>



                        <h3 className="rubik-font" style={{ marginLeft: '15px', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginTop: '50px' }}>Enteric Pathogens by Source</h3>

                        <Grid container spacing={2} sx={{ paddingLeft: 2, paddingRight: 1 }} justifyContent="center" alignItems="center">
                            <Grid item xs={12} sm={12} md={6} lg={6} >
                                <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '10px', }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Uncooked Food</h3>
                                    {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Uncooked Food</h5> */}
                                    <ReactECharts option={pieoption1} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} >
                                <div className="piechartbox" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '10px', }}>
                                    <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Cooked Food</h3>
                                    {/* <h5 className="rubik-font" style={{ fontWeight: 200, fontFamily: 'Rubik, sans-serif', color: 'black' }}>Cooked Food</h5> */}
                                    <ReactECharts option={pieoption2} style={{ width: '100%', marginTop: '30px', height: '500px' }} />
                                </div>
                            </Grid>
                        </Grid>

                        <h3 className="rubik-font" style={{ marginLeft: '15px', fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginTop: '50px' }}>Time Distribution of Enteric Pathogens</h3>

                        <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 1 }} style={{ display: 'flex', justifyContent: "flex-start", marginTop: '15px' }} >
                            <Grid item xs={12} md={6} lg={4}>
                                <div>
                                    <TextField

                                        required
                                        fullWidth
                                        id="outlined-select-district"
                                        select
                                        label="Select State"
                                        value={state}
                                        onChange={
                                            (e) => setstate(e.target.value)
                                            //setdistrict(centers.filter(op => op.center_dist_id === district))
                                        }
                                        InputLabelProps={inputlabelprops}
                                        sx={{ backgroundColor: 'white' }}


                                    // InputProps={{
                                    //   readOnly: true,
                                    // }}
                                    //onChange={handleChange}
                                    >
                                        {statemaster.map((option) => (
                                            <MenuItem key={option.stateId} value={option.stateId}>
                                                {option.stateName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 1 }} >

                            {
                                timedatapath.map((item, key) => (
                                    <>
                                        <Grid key={key} item xs={12} sm={12} md={12} lg={12}>
                                            <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                                <TimeSeriesChartComponent pathname={item.pathname} sec={""} dataseries={item.series}></TimeSeriesChartComponent>
                                            </div>
                                        </Grid>
                                    </>
                                ))
                            }

                        </Grid>

                    </Box>
                </div>
            </Box>
            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                {/* <CircularProgress color="inherit" /> */}

                <div className="boxes">
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </Backdrop>
        </>
    )
}
